export const facultyFields = [
    {
        section: "Basic Information",
        fields: [
            { name: "firstName", label: "First Name", required: true, type: "text" },
            { name: "middleName", label: "Middle Name", type: "text" },
            { name: "lastName", label: "Last Name", required: true, type: "text" },
            { name: "gender", label: "Gender", required: true, type: "select", options: ["MALE", "FEMALE", "OTHER"] },
            { name: "dob", label: "Date of Birth", required: true, type: "date" },
            { name: "placeOfBirth", label: "Place of Birth", type: "text" },
            { name: "bloodGroup", label: "Blood Group", type: "select", options: ["A_POSITIVE", "A_NEGATIVE", "B_POSITIVE", "B_NEGATIVE", "O_POSITIVE", "O_NEGATIVE", "AB_POSITIVE", "AB_NEGATIVE"] },
            { name: "nationality", label: "Nationality", type: "text" },
            { name: "religion", label: "Religion", type: "text" },
            { name: "category", label: "Category", type: "text" },
            { name: "email", label: "Email", required: true, type: "email" },
            { name: "phoneNumber", label: "Phone Number", required: true, type: "text", maxLength: 10 },
            { name: "lastFourDigitsOfAadhaarNumber", label: "Last Four Digits of Aadhaar", type: "text", maxLength: 4 },
        ]
    },
    {
        section: "Contact Information",
        fields: [
            { name: "currentAddress", label: "Address", type: "text" },
            { name: "currentAddress2", label: "Address Line 2", type: "text" },
            { name: "city", label: "City", required: true, type: "text" },
            { name: "state", label: "State", type: "text" },
            { name: "country", label: "Country", type: "text" },
            { name: "pincode", label: "Pincode", type: "text" },
            { name: "alternatePhoneNumber", label: "Alternate Contact Number", type: "text", maxLength: 10 },
            { name: "area", label: "Area", type: "text" },
            { name: "latitude", label: "Latitude", type: "text" },
            { name: "longitude", label: "Longitude", type: "text" },
        ]
    },
    {
        section: "Faculty Information",
        fields: [
            { name: "facultyType", label: "Faculty Type", required: true, type: "select", options: [
                "PRIMARY_TEACHER",
                "MIDDLE_SCHOOL_TEACHER",
                "HIGH_SCHOOL_TEACHER",
                "SENIOR_HIGH_SCHOOL_TEACHER",
                "HEADMASTER",
                "PRINCIPAL",
                "ASSISTANT_PROFESSOR",
                "ASSOCIATE_PROFESSOR",
                "FULL_PROFESSOR",
                "LECTURER",
                "INSTRUCTOR",
                "ADJUNCT",
                "VISITING_PROFESSOR",
                "EMERITUS",
                "HEAD_OF_DEPARTMENT",
                "DEAN",
                "DIRECTOR",
                "VICE_CHANCELLOR",
                "CHANCELLOR",
                "NIRVAHAK",
                "PARYAVEKSHAK",
                "SAMANVAYKARTA"
            ] },
            { name: "employeeId", label: "Employee ID", type: "text" },
            { name: "designation", label: "Designation", type: "text" },
            { name: "department", label: "Department", type: "text" },
            { name: "joiningDate", label: "Joining Date", type: "date" },
            { name: "facultyContractType", label: "Contract Type", type: "select", options: ["PERMANENT", "TEMPORARY", "CONTRACT"] },
            { name: "responsibilities", label: "Responsibilities", type: "text" },
            { name: "supervisorId", label: "Supervisor ID", required: true, type: "text" },
        ]
    }
];
